import React from 'react'
import * as Behaviours from 'alcumus-behaviours'
import { proportional } from '../proportional'
import { Group } from 'react-konva'

Behaviours.register('test', {
    methods: {
        update(dt) {
            this.document.y += dt * 20
        }
    },
    states: {
        fast: {
            methods: {
                update(dt) {
                    this.document.x += dt * 200
                }
            }
        }
    }
})
